export const BrandLogoIcon = () => (
  <svg width="441" height="80" viewBox="0 0 441 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M324.418 1L360.681 37.8132L355.736 42.7582L324.418 11.4396L301.89 33.967C310.681 42.7582 328.318 61.7553 331.56 64.1868C333.758 65.8352 339.802 66.9341 344.198 64.1868L406.835 1L439.802 33.967C419.473 54.1136 378.264 95.1758 376.066 98.2528C373.868 101.33 373.868 105.396 376.066 108.143L406.835 139.462L429.363 116.385L398.044 84.5165L402.989 79.5714L439.802 116.934L406.835 148.802L370.571 112.538C366.176 106.824 367.214 100.451 370.571 94.4066C373.929 88.3626 429.912 33.4176 429.912 33.4176L406.835 11.4396C406.835 11.4396 351.341 67.4835 346.396 70.2308C341.451 72.978 332.11 74.0769 328.264 70.2308L292 33.967L324.418 1Z"
      fill="white"
      stroke="white"
      strokeWidth="1.0989"
    />
    <g filter="url(#filter0_i_1101_231)">
      <path d="M324.418 83.9668L292 116.384L324.967 149.351L357.385 116.934L324.418 83.9668Z" fill="#023743" />
    </g>
    <g filter="url(#filter1_i_1101_231)">
      <path
        d="M3.31055 66.5859H37.6758V81.7324H28.1543V75.4922H17.6367V84.8379H26.748V93.3633H17.6367V102.973H22.3242V111H3.31055V102.973H7.91016V75.4922H3.31055V66.5859ZM92.6379 102.973H97.0617L95.0695 96.5859H81.4172L79.425 102.973H84.1125V111H67.2668V102.973H70.5773L82.677 66.5859H94.425L106.261 102.973H109.484V111H92.6379V102.973ZM83.7316 89.0859H92.6965L88.1848 74.6426L83.7316 89.0859ZM171.389 80.0918C170.295 78.5293 169.309 77.4258 168.43 76.7812C167.551 76.1172 166.604 75.6484 165.588 75.375C164.573 75.082 163.508 74.9355 162.395 74.9355C160.754 74.9355 159.231 75.3066 157.825 76.0488C156.418 76.7715 155.198 77.7676 154.163 79.0371C153.147 80.2871 152.346 81.752 151.76 83.4316C151.174 85.0918 150.881 86.8594 150.881 88.7344C150.881 90.6289 151.164 92.416 151.731 94.0957C152.317 95.7559 153.118 97.2109 154.133 98.4609C155.149 99.7109 156.36 100.707 157.766 101.449C159.172 102.172 160.715 102.533 162.395 102.533C163.567 102.533 164.661 102.348 165.676 101.977C166.692 101.586 167.61 101.078 168.43 100.453C169.27 99.8281 170.002 99.1152 170.627 98.3145C171.252 97.4941 171.741 96.6445 172.092 95.7656L181.526 98.4023C180.92 100.316 180.032 102.094 178.86 103.734C177.688 105.355 176.272 106.762 174.612 107.953C172.971 109.145 171.116 110.082 169.045 110.766C166.995 111.449 164.778 111.791 162.395 111.791C160.383 111.791 158.459 111.518 156.623 110.971C154.788 110.424 153.069 109.652 151.467 108.656C149.885 107.66 148.44 106.459 147.131 105.053C145.842 103.646 144.739 102.094 143.821 100.395C142.903 98.6758 142.19 96.8398 141.682 94.8867C141.174 92.9141 140.92 90.8633 140.92 88.7344C140.92 85.5508 141.477 82.5723 142.59 79.7988C143.704 77.0059 145.227 74.5742 147.161 72.5039C149.094 70.4141 151.36 68.7734 153.957 67.582C156.575 66.3711 159.387 65.7656 162.395 65.7656C164.797 65.7656 166.819 66.0684 168.459 66.6738C170.1 67.2598 171.907 68.4316 173.879 70.1895H180.442V80.0918H171.389ZM216.625 66.5859H251.957V81.7324H242.406V75.4336H231.009V84.1934H239.828V92.6895H231.009V102.973H242.406V95.0918H251.957V111H216.625V102.973H221.283V75.4336H216.625V66.5859Z"
        fill="#023743"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1101_231"
        x="292"
        y="83.9668"
        width="67.3848"
        height="69.3848"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0784314 0 0 0 0 0.101961 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1101_231" />
      </filter>
      <filter
        id="filter1_i_1101_231"
        x="3.31055"
        y="65.7656"
        width="250.646"
        height="50.0254"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0784314 0 0 0 0 0.101961 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1101_231" />
      </filter>
    </defs>
  </svg>
);

export const ScaleTechIcon = () => (
  <svg width="200" height="50" viewBox="0 0 200 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="12.71"
      y="24.8398"
      width="14.5482"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 12.71 24.8398)"
      fill="black"
    />
    <rect
      x="24.6592"
      y="12.8906"
      width="9.28078"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 24.6592 12.8906)"
      fill="black"
    />
    <rect
      x="32.8848"
      y="4.66602"
      width="5.25963"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 32.8848 4.66602)"
      fill="black"
    />
    <rect
      width="14.5482"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 59.4062 23.748)"
      fill="black"
    />
    <rect
      width="9.28078"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 42.0737 41.0801)"
      fill="black"
    />
    <rect
      width="5.25963"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 47.4556 35.6973)"
      fill="black"
    />
    <rect
      x="18.4111"
      y="30.541"
      width="8.63802"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 18.4111 30.541)"
      fill="black"
    />
    <rect
      x="25.7539"
      y="23.1973"
      width="13.9604"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 25.7539 23.1973)"
      fill="#00A5CB"
    />
    <rect
      x="36.8623"
      y="12.0898"
      width="7.70524"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 36.8623 12.0898)"
      fill="black"
    />
    <rect
      x="21.2607"
      y="33.3906"
      width="5.97293"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 21.2607 33.3906)"
      fill="black"
    />
    <rect
      x="26.7583"
      y="27.8926"
      width="9.27294"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 26.7583 27.8926)"
      fill="#00A5CB"
    />
    <rect
      x="34.873"
      y="19.7793"
      width="14.5482"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 34.873 19.7793)"
      fill="black"
    />
    <rect
      width="5.97293"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 50.8608 15.1914)"
      fill="black"
    />
    <rect
      width="9.27294"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 45.3633 20.6895)"
      fill="#00A5CB"
    />
    <rect
      width="14.5482"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 37.248 28.8047)"
      fill="black"
    />
    <rect
      x="24.1104"
      y="36.2422"
      width="7.57198"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 24.1104 36.2422)"
      fill="black"
    />
    <rect
      x="31.084"
      y="29.2676"
      width="13.9447"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 31.084 29.2676)"
      fill="#00A5CB"
    />
    <rect
      x="42.6621"
      y="17.6895"
      width="7.56415"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 42.6621 17.6895)"
      fill="black"
    />
    <rect
      width="7.57198"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 53.7109 18.041)"
      fill="black"
    />
    <rect
      width="13.9447"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 46.7383 25.0137)"
      fill="#00A5CB"
    />
    <rect
      width="7.56415"
      height="1.55274"
      rx="0.776371"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 35.1602 36.5938)"
      fill="black"
    />
    <rect
      x="15.5596"
      y="27.6895"
      width="33.7917"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 15.5596 27.6895)"
      fill="black"
    />
    <rect
      x="32.6611"
      y="44.791"
      width="33.7917"
      height="1.55274"
      rx="0.776371"
      transform="rotate(-45 32.6611 44.791)"
      fill="black"
    />
    <path
      d="M74.8387 18.9009L73.5394 19.9063C72.8898 18.9627 71.9462 18.4832 70.7088 18.4832C69.8736 18.4832 69.1311 18.7152 68.5124 19.1638C67.8937 19.6124 67.5843 20.2775 67.5843 21.1282C67.5843 21.8397 67.8473 22.4275 68.3577 22.8606C68.8682 23.2937 69.5023 23.6185 70.2293 23.8505C70.9563 24.0826 71.6987 24.33 72.4257 24.593C73.1682 24.8559 73.7869 25.3045 74.3128 25.9077C74.8232 26.511 75.0862 27.2998 75.0862 28.2588C75.0862 29.5272 74.5912 30.5481 73.6013 31.3215C72.6113 32.0948 71.4977 32.4815 70.2603 32.4815C68.2495 32.4815 66.7182 31.7546 65.6509 30.3161L66.9966 29.3416C67.6926 30.5326 68.7908 31.1204 70.3221 31.1204C71.1264 31.1204 71.838 30.8729 72.4876 30.3934C73.1372 29.9139 73.4621 29.2642 73.4621 28.4445C73.4621 27.7948 73.2765 27.2689 72.9052 26.8358C72.534 26.4182 72.07 26.1088 71.5131 25.9232C70.9563 25.7376 70.3531 25.5211 69.7034 25.289C69.0538 25.057 68.4505 24.8095 67.8937 24.5621C67.3369 24.3146 66.8883 23.9124 66.5016 23.3401C66.1613 22.8142 65.9757 22.1181 65.9757 21.2829C65.9757 19.9527 66.4397 18.9163 67.3678 18.2048C68.2959 17.4778 69.4095 17.1221 70.7088 17.1221C72.4257 17.1221 73.8024 17.7098 74.8387 18.9009Z"
      fill="#00A5CB"
    />
    <path
      d="M89.7656 28.9394L90.9875 29.8056C90.4771 30.5945 89.7346 31.2287 88.7756 31.7391C87.8166 32.2495 86.7494 32.497 85.5738 32.497C83.3774 32.497 81.5677 31.77 80.1137 30.3161C78.6598 28.8621 77.9482 27.0214 77.9482 24.8095C77.9482 22.5977 78.6752 20.757 80.1137 19.303C81.5522 17.8491 83.3774 17.1221 85.5738 17.1221C86.5328 17.1221 87.4763 17.3077 88.3735 17.6944C89.2706 18.0811 90.0285 18.6534 90.6318 19.4268L89.3325 20.4012C89.0231 19.9063 88.5127 19.4577 87.7857 19.071C87.0587 18.6843 86.3163 18.4832 85.5738 18.4832C83.7486 18.4832 82.2947 19.1019 81.1965 20.3394C80.0983 21.5768 79.5569 23.0617 79.5569 24.8095C79.5569 26.5574 80.0983 28.0578 81.1965 29.2797C82.2947 30.5171 83.7486 31.1358 85.5738 31.1358C87.4145 31.1358 88.8066 30.4089 89.7656 28.9394Z"
      fill="#00A5CB"
    />
    <path
      d="M95.6726 28.2896L94.0639 32.1257H92.3315L98.7042 17.4932H100.158L106.5 32.1257H104.768L103.159 28.2742H95.6726V28.2896ZM99.4157 19.2256L96.2294 26.913H102.571L99.4157 19.2256Z"
      fill="#00A5CB"
    />
    <path d="M110.801 17.4932V30.7645H117.622V32.1257H109.316V17.4932H110.801Z" fill="#00A5CB" />
    <path
      d="M121.969 25.1961V30.749H129.795V32.1257H120.468V17.4932H129.548V18.8543H121.969V23.8349H129.053V25.1961H121.969Z"
      fill="#00A5CB"
    />
    <path d="M135.89 32.1257V20.3392H131.714V17.4932H143.284V20.3392H139.107V32.1257H135.89Z" fill="black" />
    <path
      d="M145.882 32.1257V17.4932H155.828V20.463H149.115V23.1853H155.457V26.1551H149.115V29.1249H156.199V32.1257H145.882Z"
      fill="black"
    />
    <path
      d="M171.651 19.2721L169.176 21.2984C168.495 20.494 167.583 20.1073 166.407 20.1073C165.185 20.1073 164.164 20.5559 163.375 21.4376C162.571 22.3192 162.184 23.4484 162.184 24.8095C162.184 26.1552 162.586 27.2844 163.375 28.1815C164.164 29.0786 165.154 29.5272 166.314 29.5272C167.629 29.5272 168.634 29.0013 169.33 27.9495L172.022 29.9603C171.434 30.7956 170.661 31.4297 169.717 31.8628C168.774 32.2959 167.784 32.497 166.732 32.497C164.412 32.497 162.525 31.801 161.055 30.3934C159.586 28.9858 158.843 27.1297 158.843 24.8095C158.843 22.4894 159.586 20.6332 161.055 19.2257C162.494 17.8181 164.396 17.1221 166.701 17.1221C167.629 17.1221 168.526 17.2922 169.423 17.6325C170.336 17.9883 171.063 18.5296 171.651 19.2721Z"
      fill="black"
    />
    <path
      d="M174.575 32.1257V17.4932H177.807V22.9533H184.072V17.4932H187.289V32.1257H184.072V25.7993H177.807V32.1257H174.575Z"
      fill="black"
    />
  </svg>
);
